import { useTranslation } from "react-i18next";

import VerticalMenu from "../../../ui/components/VerticalMenu/VerticalMenu";
import useMenuDocTitle from "../../../ui/hooks/useMenuDocTitle";
import PageView from "../../../ui/views/PageView/PageView";

import useOrganizationSettingsMenuOptions from "./hooks/useOrganizationSettingsMenuOptions";

export default function OrganizationSettingsView({ organization, children }) {
	const { t } = useTranslation();

	const options = useOrganizationSettingsMenuOptions({ organization });

	useMenuDocTitle(t("settings", "Settings"), options);

	return (
		<PageView header={organization.name} sidebar={<VerticalMenu options={options} />}>
			{children}
		</PageView>
	);
}
